import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Card from 'react-bootstrap/Card';
import styled from 'styled-components';
import api from '../../../../api/areas'

const StyledSection1Card = styled(Card)`
    border: none;
    box-shadow: 0rem 0.3125rem 0.3125rem 0rem rgb(82 63 105 / 5%);
    transition: all .5s ease-in-out;
    border-radius: .75rem;
    background-color: ${({ theme }) => theme.colors.background.elements};
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 100%;

    span{
        height: 4rem;
        min-width: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({ theme }) => theme.colors.primary_1};
        color: ${({ theme }) => theme.colors.primary};
        font-size: 2rem;
        border-radius: 0.5rem;
        transition: all .5s ease-in-out;
    }
    h2{
        font-weight: 700;
        font-size: 14px;
    }
    p{
        text-transform: capitalize;
    }

    &:hover{
        box-shadow: 0 1.188rem 1.188rem rgb(0 0 0 / 16%) !important;

        span{
            color: #fff;
            background-color: ${({ theme }) => theme.colors.primary};
        }
    }
`;

const Section1Card = ({ carddata }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        api.get(carddata.countUrl).then(result => {
            setCount(result.headers['x-total-count'])
        });
    }, [])
    return (
        <StyledSection1Card >
            <Card.Body className='d-flex align-items-center p-3'>
                <span>
                    {carddata.icon}
                </span>
                <div className='ms-2'>
                    <h2 className='mb-0'>
                        {carddata.title}
                    </h2>
                    <p className='mb-0 numbers-font'>
                        {count}
                    </p>
                </div>
            </Card.Body>
        </StyledSection1Card>
    );
}

export default Section1Card;